import React from 'react';
import { Stack } from 'react-bootstrap';
import ClientDashboardHeader from '../../components/client-dashboard/client-dashboard-header';
import ClientDashboardContent from '../../components/client-dashboard/client-dashboard-content';

function ClientDashboard() {
  return (
    <Stack gap={1}>
      <ClientDashboardHeader />
      <ClientDashboardContent />
    </Stack>
  );
}

export default ClientDashboard;
